var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"geoChart",staticClass:"chart-root",attrs:{"id":"elementId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }